import { render, staticRenderFns } from "./About.vue?vue&type=template&id=1f722c3a&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.scss?vue&type=style&index=0&id=1f722c3a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f722c3a",
  null
  
)

export default component.exports